import { Component, Input, OnChanges, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { KamService } from '@app/shared/services/kam.service';
import { isNil } from 'lodash';
import { environment } from '@env/environment';
import { UserService } from '@app/shared/services/api/user.service';
import { AuthService } from '@app/shared/services/auth.service';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { KamUser } from '@app/shared/models/user';

@Component({
  selector: 'app-kam-contact-info-v2',
  templateUrl: './kam-contact-info-v2.component.html',
  styleUrls: ['./kam-contact-info-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KamContactInfoV2Component implements OnChanges {
  @Input() municipalityId!: string;
  @Output() kamInitialized = new EventEmitter();
  kamUser: KamUser = {} as KamUser;
  imageSrc!: string;
  isImageLoading = true;
  senderEmail!: string;

  constructor(
    public kamService: KamService,
    public userService: UserService,
    public authService: AuthService,
    public azureBlob: AzureBlobStorageService,
    public translate: TranslateService
  ) {
    this.senderEmail = environment.companyGroupEmail;
  }

  ngOnChanges() {
    if (this.municipalityId) {
      this.kamService.getByMunicipalityIdDirect(this.municipalityId).subscribe((m) => {
        this.kamUser = {
          email: !isNil(m) ? m.email : environment.companyGroupEmail,
          firstName: !isNil(m) ? m.firstname : environment.companyGroupEmail,
          lastName: !isNil(m) ? m.lastname : '',
          textT: !isNil(m) ? m.telefon : '',
          textF: !isNil(m) ? m.fax : '',
          company: !isNil(m) ? m.company : '',
          mobile: !isNil(m) ? m.mobil : '',
          imageSrc: !isNil(m) ? m.imageName : '',
        };

        if (this.kamUser.imageSrc) {
          this.azureBlob.getBlobImageSafeUrl(`${environment.tenant}/assets/images/users/${this.kamUser.imageSrc}`).subscribe({
            next: (imageTitle: any) => {
              this.imageSrc = imageTitle;
              this.isImageLoading = false;
            },
            error: () => {
              this.imageSrc = '';
              this.isImageLoading = false;
            },
          });
        } else {
          this.imageSrc = '';
          this.isImageLoading = false;
        }

        this.kamInitialized.emit(this.kamUser);
      });
    }
  }

  mailer() {
    const mail = this.senderEmail;
    window.location.href = `mailto:${mail}`;
  }

  dialer(telephone: string) {
    window.location.href = `tel:${telephone}`;
  }
}
